import { Component, ViewChild } from '@angular/core';
import { AccountCenterSection } from '../utilities/accountCenterSection.component';
import { AccountCenterService } from '../../../services/account-center/account-center.service';
import { AccountCenterTable } from '../account-center-table/account-center-table.component';
import { AmorphicService } from '../../../services/amorphic/amorphic.service';
import { AccountCenterTableRow } from '../../../classes/account-center/AccountCenterTableRow';
import { AccountCenterTableCell } from '../../../classes/account-center/AccountCenterTableCell';

@Component({
  selector: 'annuity-info-table',
  moduleId: module.id,
  template: '<account-center-table></account-center-table>',
})
export class AnnuityInfoTableComponent extends AccountCenterSection {
  @ViewChild(AccountCenterTable, { static: true }) table: AccountCenterTable;

  constructor(accountCenterService: AccountCenterService, amorphicService: AmorphicService) {
    super(amorphicService, accountCenterService);
  }

  ngOnInit(): void {
    this.subscribeToAccountCenterService();
  }

  processWorkflowAction(workflowAction: string): void {
    if (this.hasInForcePolicy) {
      this.table.title = 'Annuity Information';
    } else {
      this.table.title = 'Application Information';
    }

    const tableRows = new Array<AccountCenterTableRow>();
    tableRows.push(
      new AccountCenterTableRow([
        new AccountCenterTableCell('heading', 'Owner'),
        new AccountCenterTableCell('data', this.accountCenterService.primaryPolicy.owner.getFullNameOfOwner()),
      ])
    );

    this.table.rows = tableRows;
  }
}
